import { FilterType } from "@domain/enums/FilterType";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { countriesExtendedAll } from "@studyportals/static-domain-data/countries/countries-extended";
import { countryGetIsoCodePath } from "@studyportals/static-domain-data/countries/country-get-iso-path";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";

export class CountryFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.COUNTRY;
	public isMultiSelect = true;
	private static instance: CountryFilterMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] =[];
	private isoToIdMap: Map<string, string> = new Map();

	// TODO original processor had some extra logic for sorting countries by name, should we add it here?
	public static getInstance(): CountryFilterMapper {
		if (!CountryFilterMapper.instance) {
			CountryFilterMapper.instance = new CountryFilterMapper();
		}
		return CountryFilterMapper.instance;
	}

	private constructor() {
		super();

		for(const country of countriesExtendedAll) {
			const virtualPath = countryGetIsoCodePath(country.iso!);
			if(virtualPath){
				this.values.push({
					id: country.iso!,
					virtualPath,
					name: country.name
				});
				if (country.id) {
					this.isoToIdMap.set(country.iso!, country.id.toString());
				}
			}
		}
	}

	public getCountryIdFromIsoCode(isoCode: string): string | undefined {
		return this.isoToIdMap.get(isoCode);
	}


}
